import React from 'react';
import * as Antd from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './BalanceCard.css';

const { Card, Button, Typography, theme } = Antd;
const { Text } = Typography;
const borderBeamExport = 'BorderBeam';
const BorderBeam = Antd[borderBeamExport];

const BalanceBeam = ({ children, color }) => {
  if (BorderBeam) {
    return (
      <BorderBeam color={color} outset={0}>
        {children}
      </BorderBeam>
    );
  }

  return (
    <div
      className="balance-card-border-beam"
      style={{
        '--balance-beam-start': color[0]?.color || '#52c41a',
        '--balance-beam-middle': color[1]?.color || '#95de64',
        '--balance-beam-end': color[2]?.color || '#36cfc9',
      }}
    >
      {children}
    </div>
  );
};

const BalanceCard = ({ user, onAddCoins, cardStyle }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const coins = user?.balance?.available_coins || 0;
  const beamColor = [
    { color: token.colorPrimary || '#1677ff', percent: 0 },
    { color: token.colorPrimaryBorder || '#91caff', percent: 55 },
    { color: token.colorBorder || '#d9d9d9', percent: 100 },
  ];

  return (
    <BalanceBeam color={beamColor}>
      <Card
        className="balance-card"
        style={{
          ...cardStyle,
          height: '100%',
          position: 'relative',
          boxShadow: token.boxShadowTertiary || '0 1px 3px rgba(0, 0, 0, 0.08)',
        }}
        title={t('balance')}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onAddCoins}
          >
            {t('need_coins')}
          </Button>
        }
      >
        <Text strong style={{ fontSize: '2rem' }}>
          {coins.toLocaleString()} {t('coins')}
        </Text>
      </Card>
    </BalanceBeam>
  );
};

export default BalanceCard;
